// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"5cfe37e6","881":"f383d078"}[chunkId] + ".chunk.css";
};